import { type ActionFunction, redirect } from "react-router-dom";
import { UsersApi } from "@green0meter/api-client";

export const registerMFAAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const api = new UsersApi(undefined, import.meta.env.VITE_API_BASE_URL);

  if (!formData.get("secret") || !formData.get("code")) {
    return null;
  }

  const mfaResult = await api.usersControllerValidateAuthenticatorData({
    secret: formData.get("secret") as string,
    otp: formData.get("code") as string,
  });

  const user = await api.usersControllerGetProfile();

  if (mfaResult.data.isValid) {
    if (user.data.mfaMethod === 0) {
      await api.usersControllerSetMfaAuthenticatorSecret({
        secret: formData.get("secret") as string,
      });
    }

    return redirect("/");
  }

  return mfaResult.data;
};
